import React from "react";
import Paper from "material-ui/Paper";
import { Tabs, Tab } from "material-ui/Tabs";
import IntrusionAlertList from "../../../../components/services/IntrusionAlertList";

import { services as ROLES_CONFIG } from "../../../../config/roles";
import { store } from "../../../../stores/configureStore";
import { push } from "react-router-redux";

import DataService from "../../../../services/DataService";
var ds = DataService;

export default class IntrusionAlerts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      role: this.props.authenticated ? this.props.authenticated.role : null,
      user: this.props.authenticated ? this.props.authenticated.user : null,
      accesible_services: this.props.authenticated
        ? this.props.authenticated.user.accessible_service
        : [],
      root_user: this.props.authenticated
        ? this.props.authenticated.user.root_user
        : false,
      all_services: [],
      selectedID:
        this.props && this.props.match && this.props.match.params
          ? this.props.match.params.name
          : "all",
    };
    if (
      this.props.authenticated &&
      this.props.authenticated.role == "hotel_admin"
    ) {
      //this.getAllServices();
    }
  }

  handleChange(e) {
    let item = e == "Food Order" ? "Food" : e;
    this.setState({ selectedID: "all" });
  }

//   getAllServices() {
//     ds.getIntrusionHistory(
//       (data) => {
//         // if (this.state.selectedID == "all") {
//         //   this.setState({
//         //     selectedID: "",
//         //   });
//         // }
//         let services = [];
//           services = data.intrusion_history;
        
//         this.setState({
//           all_services: services,
//         });
//       },
//       (err) => {}
//     );
//   }

  render() {
    return (
      <div id="content" style={{ width: "100%" }}>
        <Paper className="row">
          { ROLES_CONFIG.requests.indexOf(this.state.role) != -1 &&
           (
            <IntrusionAlertList
                        selectedID={this.state.selectedID}
                        serviceChange={(e) => {
                          this.handleChange(e);
                        }}
                        />
           )
          }
        </Paper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./routes/app/routes/services/IntrusionAlerts.js